import { lazy } from 'react'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'

export default {
  path: '/team',
  exact: false,
  Component: WithPermission(
    lazy(() => import('./TeamContainer')),
    ['page:team'],
    true
  ),
  access: 'USER',
  routes: [
    {
      path: '/team',
      exact: true,
      Component: lazy(() => import('./TeamPage')),
      access: 'USER',
    },
    {
      path: '/team/csview',
      exact: true,
      Component: lazy(() => import('./CSViewPage')),
      access: 'USER',
    },
  ],
}
